import React, { useState } from "react";
import { Modal, Button, Form } from "react-bootstrap";
import { toast } from "react-toastify";
import { useAddSwapMutation } from "../../redux/swapApi";
import { useGetCryptocurrencyQuery } from "../../redux/cryptocurrencyApi";

import { useTranslation } from "react-i18next";

function AddSwap({ show, onHide }) {
    const { t } = useTranslation();
    const [addData, setAddData] = useState({ status: "enable" });
    const [addSwap] = useAddSwapMutation();
    const { data: coinResponse } = useGetCryptocurrencyQuery();
    const coins = coinResponse?.data || [];

    const handleAddSave = async () => {
        if (!addData.from_coin_id || !addData.to_coin_id || !addData.swap_rate || !addData.status) {
            toast.error("All fields are required!");
            return;
        }
        try {
            const response = await addSwap(addData).unwrap();
            if (response.status) {
                toast.success(response.message || "Swap added successfully!");
                onHide();
                setAddData({ status: "enable" });
            } else {
                toast.error(response.message || "Failed to add swap");
            }
        } catch (error) {
            toast.error("Error adding swap");
            console.error("Error adding swap:", error);
        }
    };

    return (
        <Modal show={show} onHide={onHide}>
            <Modal.Header closeButton>
                <Modal.Title>{t('add_swap')}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Form>
                    <Form.Group className="mb-3">
                        <Form.Label>{t('from_coin')}</Form.Label>
                        <Form.Select
                            value={addData.from_coin_id || ""}
                            onChange={(e) => setAddData({ ...addData, from_coin_id: e.target.value })}
                        >
                            <option value="">{t('select_coin')}</option>
                            {coins.map((coin, index) => (
                                <option key={index} value={coin.id}>
                                    {coin.coin_symbol} ({coin.symbol})
                                </option>
                            ))}
                        </Form.Select>
                    </Form.Group>
                    <Form.Group className="mb-3">
                        <Form.Label>{t('to_coin')}</Form.Label>
                        <Form.Select
                            value={addData.to_coin_id || ""}
                            onChange={(e) => setAddData({ ...addData, to_coin_id: e.target.value })}
                        >
                            <option value="">{t('select_coin')}</option>
                            {coins.map((coin, index) => (
                                <option key={index} value={coin.id}>
                                    {coin.coin_symbol} ({coin.symbol})
                                </option>
                            ))}
                        </Form.Select>
                    </Form.Group>
                    <Form.Group className="mb-3">
                        <Form.Label>{t('swap_rate')}</Form.Label>
                        <Form.Control
                            type="text"
                            value={addData.swap_rate || ""}
                            onChange={(e) => setAddData({ ...addData, swap_rate: e.target.value })}
                        />
                    </Form.Group>
                    <Form.Group className="mb-3">
                        <Form.Label>{t('status')}</Form.Label>
                        <Form.Select
                            value={addData.status || "enable"}
                            onChange={(e) => setAddData({ ...addData, status: e.target.value })}
                        >
                            <option value="enable">{t('enable')}</option>
                            <option value="disable">{t('disable')}</option>
                        </Form.Select>
                    </Form.Group>
                </Form>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={onHide}>
                    {t('close')}
                </Button>
                <Button variant="primary" onClick={handleAddSave}>
                    {t('add_swap')}
                </Button>
            </Modal.Footer>
        </Modal>
    );
}

export default AddSwap;
